import { missingFirebaseKeys } from '../firebase/app';

/**
 * Ecran d'installation.
 *
 * Il s'affiche tant que `client/.env.local` n'est pas renseigne. Sans
 * lui, l'application planterait sur une erreur Firebase illisible : mieux
 * vaut dire exactement ce qui manque et ou le trouver.
 */
export function SetupScreen() {
  const missing = missingFirebaseKeys();

  return (
    <div className="setup">
      <h1 className="setup__title">Connexion à Firebase</h1>
      <p className="setup__lead">
        L'application est prête, il ne manque que la configuration de ton projet Firebase.
      </p>

      <ol className="setup__steps">
        <li>
          Dans la console Firebase, ouvre <strong>Paramètres du projet</strong> puis{' '}
          <strong>Vos applications</strong>. S'il n'y a pas encore d'application Web, crée-en une
          avec l'icône <code>&lt;/&gt;</code>.
        </li>
        <li>
          Copie le bloc <code>firebaseConfig</code> qui s'affiche.
        </li>
        <li>
          Duplique <code>client/.env.example</code> en <code>client/.env.local</code> et reporte les
          valeurs.
        </li>
        <li>
          Dans <strong>Authentication ▸ Sign-in method</strong>, active{' '}
          <strong>E-mail/Mot de passe</strong>.
        </li>
        <li>
          Relance <code>npm run dev</code>, Vite ne relit pas les variables à chaud.
        </li>
      </ol>

      {missing.length > 0 && (
        <div className="setup__missing">
          <p className="setup__missing-title">Variables encore vides</p>
          <ul>
            {missing.map((key) => (
              <li key={key}>
                <code>{key}</code>
              </li>
            ))}
          </ul>
        </div>
      )}

      <p className="setup__note">
        Ces valeurs ne sont pas des secrets : elles partent dans le code envoyé au navigateur, et
        Firebase est conçu ainsi. Ce qui protège les données, ce sont les règles de sécurité du
        fichier <code>database.rules.json</code>.
      </p>
    </div>
  );
}
